import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => {
  return {
    path: "overview",

    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(
            /* webpackChunkName: "project-group" */ "./ProjectDeadlineOverview"
          ),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [],
  };
};
